import { useUpdated } from "@common/lib/hooks";
export * from "@common/lib/hooks";

export const useDidUpdate = useUpdated;
